// Azure AD authentication configuration for Bank Wiki
// Different clientId and authority for each environment

export interface AuthConfig {
  clientId: string;
  authority: string;
}

// Get configuration based on environment
export const getAuthConfig = (): AuthConfig => {
  const clientId = import.meta.env.VITE_AZURE_CLIENT_ID || "";
  const authority = import.meta.env.VITE_AZURE_AUTHORITY || "";

  if (!clientId || !authority) {
    console.error('[Bank Wiki] Azure AD configuration missing. Please set VITE_AZURE_CLIENT_ID and VITE_AZURE_AUTHORITY environment variables.');
  }

  return {
    clientId,
    authority
  };
};
